import React, { createContext, useState, useContext } from 'react';

export interface UserProfile {
  ethnicity: string;
  religion: string;
  location: string;
  politicalView: string;
  topic: string;
  verified: boolean;
  veteran: boolean;
  userName: string;
  userHandle: string;
}

interface UserProfileContextType {
  userProfile: UserProfile;
  updateUserProfile: (profile: Partial<UserProfile>) => void;
}

const defaultProfile: UserProfile = {
  ethnicity: "select",
  religion: "select",
  location: "select",
  politicalView: "select",
  topic: "",
  verified: false,
  veteran: false,
  userName: "American",
  //userHandle: "@America"
  userHandle: ""
};

const UserProfileContext = createContext<UserProfileContextType>({
  userProfile: defaultProfile,
  updateUserProfile: () => {}
});

export const UserProfileProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  // Try to load from localStorage first
  const savedProfile = localStorage.getItem('userProfile');
  const initialProfile = savedProfile ? JSON.parse(savedProfile) : defaultProfile;
  
  const [userProfile, setUserProfile] = useState<UserProfile>(initialProfile);
  
  const updateUserProfile = (updates: Partial<UserProfile>) => {
    const updatedProfile = {...userProfile, ...updates};
    setUserProfile(updatedProfile);
    // Save to localStorage for persistence
    localStorage.setItem('userProfile', JSON.stringify(updatedProfile));
  };
  
  return (
    <UserProfileContext.Provider value={{ userProfile, updateUserProfile }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => useContext(UserProfileContext);